import { render, staticRenderFns } from "./RoomFloating.vue?vue&type=template&id=0807f86a&scoped=true"
import script from "./RoomFloating.vue?vue&type=script&lang=js"
export * from "./RoomFloating.vue?vue&type=script&lang=js"
import style0 from "./RoomFloating.vue?vue&type=style&index=0&id=0807f86a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0807f86a",
  null
  
)

export default component.exports